import React from "react";
import imgBg from "../images/parc/IMG_3812.jpg";

class Boutique extends React.Component {
    componentDidMount() {
        document.title = "Boutique - DiscovRide | Calendriers d'affluence, Temps d'attente de parcs d'attractions (Futuroscope, Parc Asterix...)";
        this.props.handleMenu(false);
    }
    
    render() {
        return <div className="pboutique" style={{backgroundImage: `url('${imgBg}')`}}>
            <h2 className="pboutique__ttl">Ouverture bientôt</h2>
        </div>
    }
}

export default Boutique;